module.exports = __webpack_public_path__ + "img/appltCourse-img21.762f560a.png";